import { parse } from './parse.function';
import { SemanticVersion } from './semantic-version';

export function diff(version1: SemanticVersion | string, version2: SemanticVersion | string) {
  const v1 = parse(version1, true);
  const v2 = parse(version2, true);
  const comparison = v1.compare(v2);

  if (comparison === 0) {
    return null;
  }

  const v1Higher = comparison > 0;
  const highVersion = v1Higher ? v1 : v2;
  const lowVersion = v1Higher ? v2 : v1;
  const highHasPre = !!highVersion.prerelease.length;
  const lowHasPre = !!lowVersion.prerelease.length;

  if (lowHasPre && !highHasPre) {
    if (!lowVersion.patch && !lowVersion.minor) {
      return 'major';
    }

    if (lowVersion.compareMain(highVersion) === 0) {
      if (lowVersion.minor && !lowVersion.patch) {
        return 'minor';
      }
      return 'patch';
    }
  }

  const prefix = highHasPre ? 'pre' : '';

  if (v1.major !== v2.major) {
    return prefix + 'major';
  }

  if (v1.minor !== v2.minor) {
    return prefix + 'minor';
  }

  if (v1.patch !== v2.patch) {
    return prefix + 'patch';
  }

  return 'prerelease';
}
